module.exports = __webpack_public_path__ + "install-app-8a0aac1fa17542a71f5c.png";